import { i as e } from "./linkout-teaser.service-B5YdKRDR.js";
import { defineAsyncComponent as t } from "vue";
import { getI18n as n } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var r = {
	en: {
		linkoutTeaserApi: {
			createAlreadyExists: "Can't create LinkoutTeaser because another LinkoutTeaser with this name already exists",
			updateAlreadyExists: "Can't update LinkoutTeaser because another LinkoutTeaser with this name already exists",
			created: "LinkoutTeaser created",
			updated: "LinkoutTeaser updated",
			notFound: "LinkoutTeaser not found",
			requiredFields: "You can't save the LinkoutTeaser because mandatory information is missing"
		},
		linkoutTeaserList: {
			newButton: "New LinkoutTeaser",
			name: "Search by internal name, kicker or title",
			deleteLinkoutTeaser: "Delete",
			dpAny: "All",
			loading: "Loading LinkoutTeaser",
			headerType: "Type",
			headerBrand: "Brand",
			headerInternalName: "Internal name",
			headerContent: "Content",
			headerLink: "Link",
			headerChangedAt: "Changed at",
			typeInternal: "Internal",
			typeApi: "API",
			nofollow: "nofollow",
			openInNewTab: "new tab",
			hasVideo: "with Video",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error on deleting",
			createLinkoutTeaser: "Create LinkoutTeaser"
		},
		linkoutTeaser: {
			linkoutTeaserLabel: "LinkoutTeaser",
			isAd: "Linkout Teaser",
			backButton: "Back to LinkoutTeaser list",
			newLinkoutTeaser: "New LinkoutTeaser",
			messageDeleteLinkoutTeaser: "Delete LinkoutTeaser",
			messageDeleteLinkoutTeaserTitle: "Are you sure you want to delete this LinkoutTeaser?",
			deleteLinkoutTeaser: "Delete",
			messageDeleted: "LinkoutTeaser Deleted",
			errorOnDeleting: "There was an error deleting the LinkoutTeaser ",
			errorFailedLoadedLinkoutTeaserWithId: "There was an error getting the LinkoutTeaser",
			handledInLegacySystem: "This LinkoutTeaser is being handled in {source}, you can't edit it on Vibe"
		},
		linkoutTeaserEdit: {
			basics: "Basics",
			brand: "Brand",
			title: "Title",
			internalName: "Internal Name",
			kicker: "Kicker",
			link: "Link",
			leadText: "Lead text",
			isAd: "Mark as ad",
			hasVideo: "Contains video",
			nofollow: "Nofollow link",
			openInNewTab: "Open in new tab",
			imageSelectorDescription: "Select or upload image",
			backButton: "Back to LinkoutTeaser list",
			editLinkoutTeaser: "Edit LinkoutTeaser",
			messageSaved: "New LinkoutTeaser saved"
		}
	},
	de: {
		linkoutTeaserApi: {
			createAlreadyExists: "LinkoutTeaser kann nicht erstellt werden, da bereits ein LinkoutTeaser mit diesem Namen existiert",
			updateAlreadyExists: "LinkoutTeaser kann nicht aktualisiert werden, da bereits ein LinkoutTeaser mit diesem Namen existiert",
			created: "LinkoutTeaser erstellt",
			updated: "LinkoutTeaser aktualisiert",
			notFound: "LinkoutTeaser nicht gefunden",
			requiredFields: "Sie können den LinkoutTeaser nicht speichern, da obligatorische Informationen fehlen"
		},
		linkoutTeaserList: {
			newButton: "Neuer LinkoutTeaser",
			name: "Suche nach internem Namen, Vorzeile oder Titel",
			deleteLinkoutTeaser: "Löschen",
			dpAny: "Alle",
			loading: "Lade LinkoutTeaser",
			headerType: "Typ",
			headerBrand: "Marke",
			headerInternalName: "Interner Name",
			headerContent: "Inhalt",
			headerLink: "Link",
			headerChangedAt: "Geändert am",
			typeInternal: "Internal",
			typeApi: "API",
			nofollow: "nofollow",
			openInNewTab: "neuer Tab",
			hasVideo: "mit Video",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createLinkoutTeaser: "LinkoutTeaser erstellen"
		},
		linkoutTeaser: {
			linkoutTeaserLabel: "LinkoutTeaser",
			isAd: "Linkout Teaser",
			backButton: "Zurück zur LinkoutTeaser-Liste",
			newLinkoutTeaser: "Neues LinkoutTeaser",
			messageDeleteLinkoutTeaser: "LinkoutTeaser löschen",
			messageDeleteLinkoutTeaserTitle: "Sind Sie sicher, dass Sie dieses LinkoutTeaser löschen möchten?",
			deleteLinkoutTeaser: "Löschen",
			messageDeleted: "LinkoutTeaser gelöscht",
			errorOnDeleting: "Es gab einen Fehler beim Löschen des LinkoutTeasers",
			errorFailedLoadedLinkoutTeaserWithId: "Es gab einen Fehler beim Abrufen des LinkoutTeasers",
			handledInLegacySystem: "Dieser LinkoutTeaser wird in {source} behandelt, Sie können ihn nicht auf Vibe bearbeiten"
		},
		linkoutTeaserEdit: {
			basics: "Basics",
			brand: "Marke",
			title: "Hauptzeile",
			internalName: "Interner Name",
			kicker: "Vorzeile",
			link: "Link",
			leadText: "Vorspann",
			isAd: "Als Anzeige markieren",
			hasVideo: "Enthält Video",
			nofollow: "Nofollow-Link",
			openInNewTab: "In neuem Tab öffnen",
			imageSelectorDescription: "Bild auswählen oder hochladen",
			backButton: "Zurück zur LinkoutTeaser-Liste",
			editLinkoutTeaser: "LinkoutTeaser bearbeiten",
			messageSaved: "Neues LinkoutTeaser gespeichert"
		}
	}
}, i = [{
	path: "/linkout-teaser",
	children: [
		{
			path: "",
			name: "linkout_teaser_list",
			component: () => import("./linkout-teaser-list.view-CHP83lVb.js"),
			meta: { requiredRight: "linkout-teasers:navigate" }
		},
		{
			path: "new",
			name: "linkout_teaser_new",
			component: () => import("./linkout-teaser-edit.view-CZ1SVn1f.js"),
			props: () => ({
				title: n().t("linkoutTeaser.newLinkoutTeaser"),
				backRoute: "/linkout-teaser"
			}),
			meta: { requiredRight: ["linkout-teasers:navigate"] }
		},
		{
			path: ":id",
			name: "linkout_teaser_detail",
			component: () => import("./linkout-teaser-edit.view-CZ1SVn1f.js"),
			props: (e) => ({
				title: n().t("linkoutTeaserEdit.editLinkoutTeaser"),
				id: e.params.id,
				backRoute: "/linkout-teaser"
			}),
			meta: { requiredRight: ["linkout-teasers:navigate"] }
		}
	]
}], a = t(() => import("./linkout-teaser-list.view-CHP83lVb.js")), o = t(() => import("./linkout-teaser-edit.view-CZ1SVn1f.js")), s = {
	messages: r,
	routes: i
};
//#endregion
export { o as LinkoutTeaserEdit, a as LinkoutTeaserList, e as getLinkoutTeaser, s as linkoutTeaserModule };

//# sourceMappingURL=index.es.js.map